import { AccessorsMutatorsDecorator, Model } from '../../../helpers';

export class DropCashVoucher extends Model {}

AccessorsMutatorsDecorator(
    'id',
    'voucher_id',
    'shift_id',
    'created_at',
    'created_at_tz',
    'amount',
    'drop_method',
    'paid_to',
    'purpose',
    'status',
    'user_id',
    'user_name',
    'cash_drawer_id',
    'drop_method_internal',
    'bank_id',
    'notes',
)(DropCashVoucher);



// WEBPACK FOOTER //
// ./src/pms-api/models/vouchers/drop-cash-voucher.model.js